<template>
  <div id="myModal" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <span class="close" @click="$emit('closeModal')">&times;</span>
        <h2>Confirmation</h2>
      </div>
      <div class="modal-body">
        <h4>Do you want to save changes you made before proceed?</h4>
      </div>
      <div class="modal-footer">
        <button class="modal-cancel" @click="changeTabHandler">NO, DISCARD CHANGES</button>
        <button class="modal-save" @click="updateInfo">SAVE CHANGES</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    changeTab: Object
  },
  methods: {
    updateInfo() {
      let obj = {};
      obj.data = this.$store.state.ckycDetails.userCkycData;
      obj.id = this.$route.params.id;
      if (obj.data.hasOwnProperty("error_message"))
        delete obj.data.error_message;
      this.$store.dispatch("updateCKycDetail", obj);
      this.changeTabHandler();
    },
    changeTabHandler() {
      if (this.changeTab && this.changeTab.value)
        this.$emit("changeTabs", this.changeTab.tab);
      else this.$emit("goNext");
      this.$store.commit("cancelChanges");
    }
  }
};
</script>
<style scoped>
.modal {
  position: fixed;
  z-index: 1;
  padding-top: 180px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 50%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
}

@-webkit-keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}

@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}

.close {
  color: black;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.modal-header {
  padding: 2px 16px;
  border-bottom: solid 1px #e0e0e0;
}

.modal-body {
  padding: 2px 16px;
  height: 110px;
  border-bottom: solid 1px #e0e0e0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}
.modal-cancel {
  margin: 10px !important;
  font-weight: 500;
  font-size: 14px;
  /* color: #ffffff; */
  margin: 0;
  padding: 0;
  min-width: 70px;
  padding-left: 25px;
  padding-right: 25px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: solid 1px #e0e0e0;
  border-radius: 20px;
  /* border-bottom: solid 1px #e0e0e0; */
  -webkit-box-shadow: 2px 4px 7px 0 #0000001a;
  box-shadow: 2px 4px 7px 0 #0000001a;
  background-color: #ffff;
  line-height: 3em;
  height: 3em;
  cursor: pointer;
}
.modal-save {
  margin: 10px !important;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  margin: 0;
  padding: 0;
  min-width: 70px;
  padding-left: 25px;
  padding-right: 25px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none;
  border-radius: 20px;
  -webkit-box-shadow: 2px 4px 7px 0 #0000001a;
  box-shadow: 2px 4px 7px 0 #0000001a;
  background-color: #03b9f5;
  line-height: 3em;
  height: 3em;
  cursor: pointer;
}
</style>